import Config from "../../utils/Config";
import axios from "axios";

const baseUrl = Config.baseUrl;

class ProfileRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("txtconnect_ng_user_token")}`,
    };
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(`${baseUrl}api/user/update/profile`, payload, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  async changePassword(payload) {
    try {
      const response = await axios.post(
        `${baseUrl}api/user/change/password`,
        payload,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}
const profileRequests = new ProfileRequests();
export default profileRequests;
